import React from 'react'
import { Box, Divider } from '@mui/material'
import CampaignHeader from './CampaignHeader'
import CampaignInfo from './CampaignInfo'
import CampaignNavigationTabs from './CampaignNavigationTabs'

const ScrollWrapper = ({ children, style = {} }) => {
  return <div style={{ overflowX: 'hidden', flex: 1, ...style }}>{children}</div>
}

const CampaignSidebarContent = ({ campaignDetails, currentStatus, tabs, activeTab, onTabChange }) => {
  return (
    <ScrollWrapper>
      {campaignDetails && (
        <Box sx={{ p: 2 }}>
          <Box sx={{ px: 2, py: 1 }}>
            <CampaignHeader campaignDetails={campaignDetails} />

            <Divider sx={{ mt: 4, mb: 2, borderBottomWidth: 2 }} />

            <CampaignInfo
              campaignDetails={campaignDetails}
              currentStatus={currentStatus}
            />
          </Box>
        </Box>
      )}

      <Box sx={{ pt: 3, pb: 1 }}>
        <Divider sx={{ borderBottomWidth: 2 }} />
      </Box>

      <CampaignNavigationTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={onTabChange}
      />
    </ScrollWrapper>
  )
}

export default CampaignSidebarContent
